import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const nameMessages = defineMessages({
  required: {
    id: 'spanish.combos.form.name.required',
    defaultMessage: 'El nombre es requerido'
  },
  max: {
    id: 'spanish.combos.form.name.max',
    defaultMessage: 'El ombre no puede contener más de 50 caracteres'
  }
})

const categoryMessages = defineMessages({
  required: {
    id: 'spanish.combos.form.category.required',
    defaultMessage: 'La categoría es requerida'
  }
})

const subcategoryMessages = defineMessages({
  required: {
    id: 'spanish.combos.form.subcategory.required',
    defaultMessage: 'La subcategoría es requerida'
  }
})

const sellingPriceMessages = defineMessages({
  required: {
    id: 'spanish.combos.form.sellingPrice.required',
    defaultMessage: 'El precio es requerido'
  }
})

const productIdMessages = defineMessages({
  required: {
    id: 'spanish.combos.components.productId.required',
    defaultMessage: 'Se necesita seleccionar un producto'
  }
})

const componentQuantityMessages = defineMessages({
  required: {
    id: 'spanish.combos.component.quantity.required',
    defaultMessage: 'La cantidad es requerida'
  }
})

const componentsQuantityMessages = defineMessages({
  required: {
    id: 'spanish.combos.components.quantity.required',
    defaultMessage: 'Se necesita al menos 2 productos en un combo'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(50, intl.formatMessage(nameMessages.max)),
    photo: yup.string(),
    category: yup.string().required(intl.formatMessage(categoryMessages.required)),
    subcategory: yup.string().required(intl.formatMessage(subcategoryMessages.required)),
    sellingPrice: yup.string().required(intl.formatMessage(sellingPriceMessages.required)),
    components: yup
      .array()
      .of(
        yup.object().shape({
          quantity: yup.string().required(intl.formatMessage(componentQuantityMessages.required)),
          eligibleItems: yup.array().of(
            yup.object().shape({
              id: yup.string().required(intl.formatMessage(productIdMessages.required))
            })
          )
        })
      )
      .test('has at least 2 products', intl.formatMessage(componentsQuantityMessages.required), function (components) {
        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
        return components.length > 1 || components[0].quantity > 1
      })
  })
}
